module.exports = __webpack_public_path__ + "img/TIKTOK_ID.a8b73a94.svg";